import Authenticated from "@/Layouts/Authenticated";
import { capitalizeString } from "@/helpers/string";
import { Head } from "@inertiajs/inertia-react";
import { DateTime } from "luxon";
import { useMemo, useState } from "react";
import { Inertia } from "@inertiajs/inertia";
import Label from "@/Components/Label";
import DatePicker from "react-date-picker";

import { getMonthNamesBetweenDates, getFullYearsBetweenDates, parseDate, formatDate } from '@/helpers/date';

import '../../css/datepicker.css';
import 'react-calendar/dist/Calendar.css';
import ExportTable from "@/Pages/Export/Sales/Table";
import Table from "@/Components/SalesSummary/Table";
import Button from "@/Components/Button";
import { hasRole } from "@/helpers/user";
import ExportButton from "@/Components/ExportButton";
import Spinner from "@/Components/Spinner";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import GenerateExportButton from "@/Components/GenerateExportButton";
import RemoveExportButton from "@/Components/Export/RemoveExportButton";

const SalesSummary = ({ auth, office, offices, name, totals, start_date, end_date, exportRequests, ...props }) => {
    const parsedStartDate = useMemo(() => {
        return parseDate(start_date)
    }, [start_date]);

    const parsedEndDate = useMemo(() => {
        return parseDate(end_date)
    }, [end_date]);

    return (
        <Authenticated
            branchOffice={office}
            branchOffices={offices}
            store={props.store}
            auth={auth}
            errors={props.errors}
            header={
                <div className="grid grid-cols-3 items-center">
                    <div>
                        <h2 className="font-semibold text-xl text-gray-800 leading-tight">Resumen de ventas mensual</h2>
                    </div>
                    <div>
                        <h2 className="text-center font-semibold text-xl text-gray-800 leading-tight">
                            {getMonthNamesBetweenDates(parsedStartDate, parsedEndDate)} {getFullYearsBetweenDates(parsedStartDate, parsedEndDate)}
                        </h2>
                    </div>
                </div>
            }
        >
            <ToastContainer />
            <Head
                title={`Resumen de ventas mensual - ${capitalizeString(
                    props.store
                )}`}
            />

            <div className="py-4 px-8 max-w-7xl mx-auto">
                <div className="flex justify-end items-center gap-4">
                    <GenerateExportButton route="export.sales-office.pdf" date={start_date} endDate={end_date} branchOffice={office.slug}>
                        Generar reporte pdf
                    </GenerateExportButton>
                    {hasRole(auth.user, 'super_admin') && (
                        <GenerateExportButton route="export.sales-office.excel" date={start_date} endDate={end_date} branchOffice={office.slug}>
                            Generar reporte excel
                        </GenerateExportButton>
                    )}
                    {/* <div>
                        <Button style={{ maxWidth: 200 }} className="w-full flex justify-center items-center" onClick={() => handleGenerateExport('excel')} processing={!linkIsAvailable} type="button">
                            {loadingScheduling.excel ? <Spinner width="1rem" height="1rem" weight={2} color="transparent" backgroundColor="#ffffff" /> : 'Generar reporte excel'}
                        </Button>
                    </div>
                        <div>
                            <Button style={{ maxWidth: 200 }} className="w-full flex justify-center items-center" onClick={() => handleGenerateExport('pdf')} processing={!linkIsAvailable} type="button">
                                {loadingScheduling.pdf ? <Spinner width="1rem" height="1rem" weight={2} color="transparent" backgroundColor="#ffffff" /> : 'Generar reporte pdf'}
                            </Button>
                        </div>
                    )} */}
                    {/* <div className="flex justify-end items-center">
                        <a target="_blank" href={route('export.sales-office.pdf', { date: start_date, endDate: end_date, branchOffice: office.slug })}>
                            <Button type="button">Exportar en PDF</Button>
                        </a>
                    </div>

                    {hasRole(auth.user, 'super_admin') && (
                        <div className="flex justify-end items-center">
                            <a target="_blank" href={route('export.sales-office.excel', { date: start_date, endDate: end_date, branchOffice: office.slug })}>
                                <Button type="button">Exportar en Excel</Button>
                            </a>
                        </div>
                    )} */}
                </div>
                <div className="flex justify-between items-center gap-4 sm:gap-32 mb-4">
                    <div className="w-full">
                        <Label forInput="start_date" value="Desde" />
                        <DatePicker
                            id="start_date"
                            maxDate={DateTime.fromJSDate(parsedEndDate).minus({ days: 1 }).toJSDate()}
                            className="mt-1 bg-white w-full rounded-lg"
                            value={DateTime.fromJSDate(parsedStartDate).toString()}
                            required
                            onChange={(date) => Inertia.visit(route('order.summary', { start_date: DateTime.fromJSDate(date).toFormat('yyyy-MM-dd'), end_date, office: office.slug }))}
                            clearIcon={<></>}
                            calendarIcon={<svg style={{ width: '14px' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z"/></svg>}
                            format="dd/MM/yyyy"
                        />
                    </div>
                    <div className="w-full">
                        <Label forInput="end_date" value="Hasta" />
                        <DatePicker
                            id="end_date"
                            minDate={DateTime.fromJSDate(parsedStartDate).plus({ days: 1 }).toJSDate()}
                            className="mt-1 bg-white w-full rounded-lg"
                            value={DateTime.fromJSDate(parsedEndDate).toString()}
                            required
                            onChange={(date) => Inertia.visit(route('order.summary', { start_date, end_date: DateTime.fromJSDate(date).toFormat('yyyy-MM-dd'), office: office.slug }))}
                            clearIcon={<></>}
                            calendarIcon={<svg style={{ width: '14px' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z"/></svg>}
                            format="dd/MM/yyyy"
                        />
                    </div>
                </div>
                <div>
                    <Table
                        totals={totals}
                        office={office}
                        startDate={parsedStartDate}
                        endDate={parsedEndDate}
                    />
                </div>
            </div>

            <div className="px-4 max-w-7xl mx-auto">
                {exportRequests && exportRequests.length > 0 && (
                    <ExportTable title="Ultimos reportes">
                        <ExportTable.Head>
                            <ExportTable.Row>
                                <ExportTable.Header>Ordenes desde el</ExportTable.Header>
                                <ExportTable.Header>Ordenes hasta el</ExportTable.Header>
                                <ExportTable.Header>Fecha de exportación</ExportTable.Header>
                                <ExportTable.Header>Tipo</ExportTable.Header>
                                <ExportTable.Header />
                            </ExportTable.Row>
                        </ExportTable.Head>
                        <ExportTable.Body>
                            {exportRequests.map(({ id, start_date, end_date, created_at, filename }, index) => (
                                <ExportTable.Row key={index}>
                                    <ExportTable.Data>
                                        {formatDate(start_date, "dd 'de' ^MMMM 'del' yyyy")}
                                    </ExportTable.Data>
                                    <ExportTable.Data>
                                        {formatDate(end_date, "dd 'de' ^MMMM 'del' yyyy")}
                                    </ExportTable.Data>
                                    <ExportTable.Data>
                                        {formatDate(created_at, "dd 'de' ^MMMM 'del' yyyy")} <br />
                                        {formatDate(created_at, 'HH:mm:ss')}
                                    </ExportTable.Data>
                                    <ExportTable.Data>
                                        {(() => {
                                            switch (filename.split('.').pop()) {
                                                case 'pdf':
                                                    return 'PDF';
                                                case 'xlsx':
                                                    return 'Excel';
                                                default:
                                                    return '-';
                                            }
                                        })()}
                                    </ExportTable.Data>
                                    <ExportTable.Data>
                                        <div className="flex items-center justify-end gap-4">
                                            <ExportButton id={id} />
                                            {hasRole(auth.user, 'super_admin') && (
                                                <RemoveExportButton id={id} />
                                            )}
                                        </div>
                                    </ExportTable.Data>
                                </ExportTable.Row>
                            ))}
                        </ExportTable.Body>
                    </ExportTable>
                )}
            </div>

        </Authenticated>
    );
};

export default SalesSummary;
